var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesScissors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 89,
    viewBox: "0 0 110 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5475 36.1916L57.3265 34.576L58.127 33.849L61.0624 31.1833L62.5164 32.7844L101.699 75.9307L98.764 78.5964L97.3608 79.8707L96.1845 80.939L57.0015 37.7926L55.5475 36.1916Z",
    fill: "#EADDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5782 35.1242C54.5782 35.1242 53.8285 31.7275 53.1424 29.6112C53.0192 29.2312 52.8471 28.7356 52.7193 28.3723C52.6185 28.0856 52.5452 27.8813 52.5452 27.8813L50.768 25.9244L51.0349 25.682L51.3017 25.4397L53.0789 27.3966C53.0789 27.3966 53.2752 27.4892 53.5509 27.6171C53.9003 27.7792 54.3771 27.9981 54.7435 28.1572C56.7841 29.0435 60.093 30.1159 60.093 30.1159L57.3356 32.6201L54.5782 35.1242Z",
    fill: "#EADDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0349 25.682L50.768 25.9243L52.5452 27.8812L53.0789 27.3965L51.3017 25.4396L51.0349 25.682Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.069 72.6466L64.4316 27.8991L66.2106 26.2836L67.8117 24.8296L68.5233 24.1833L109.16 68.9308L108.449 69.577L106.848 71.031L105.069 72.6466Z",
    fill: "#EADDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0458 17.8579L61.6352 19.4582L62.0237 19.6982L67.5539 23.1159L63.4623 26.8317L61.1436 22.1205L60.9228 21.6718L59.0458 17.8579Z",
    fill: "#EADDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8256 20.3419L60.2624 19.1975L61.0393 19.6777L60.8256 20.3419Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8493 39.4509L32.9345 43.5361L36 72.0002L32.9345 69.0002L28.8493 39.4509Z",
    fill: "#EA5A5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1904 24.5518L58.5 62.0002V57.5002L26.9268 27.9161L20.9282 28.3967L14.4307 22.6293L14.1904 24.5518Z",
    fill: "#EA5A5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1748 30.5595L28.1283 26.2339C29.8585 25.6572 29.4901 18.6241 29.0896 15.1797H30.2911C31.4926 21.668 32.5085 27.0279 33.1748 30.5595Z",
    fill: "#EA5A5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4332,
    cy: 7.48833,
    r: 5.98833,
    stroke: "#EA5A5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1994 34.4054C32.1994 35.4671 31.3387 36.3278 30.277 36.3278C29.2152 36.3278 28.3545 35.4671 28.3545 34.4054C28.3545 33.3436 29.2152 32.4829 30.277 32.4829C31.3387 32.4829 32.1994 33.3436 32.1994 34.4054Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4767 22.4693C12.4767 25.7766 9.79559 28.4576 6.48833 28.4576C3.18107 28.4576 0.5 25.7766 0.5 22.4693C0.5 19.162 3.18107 16.481 6.48833 16.481C9.79559 16.481 12.4767 19.162 12.4767 22.4693Z",
    stroke: "#EA5A5A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61,
    y1: 0.5,
    x2: 109,
    y2: 0.5,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 88.5,
    x2: 48,
    y2: 88.5,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesScissors);
export default __webpack_public_path__ + "static/media/categoriesScissors.19a71ffb81ea436cbe49799be8beea26.svg";
export { ForwardRef as ReactComponent };